import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/pwa.awbridal.com/html/src/components/PaymentMethod/paymentMethod.js");
